import { render, staticRenderFns } from "./DetailPage.vue?vue&type=template&id=f3474638&"
import script from "./DetailPage.vue?vue&type=script&lang=ts&"
export * from "./DetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3474638')) {
      api.createRecord('f3474638', component.options)
    } else {
      api.reload('f3474638', component.options)
    }
    module.hot.accept("./DetailPage.vue?vue&type=template&id=f3474638&", function () {
      api.rerender('f3474638', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trucking/sales-order/DetailPage.vue"
export default component.exports